import React from 'react';
import { INavbarItem } from '@models/interfaces/navigation.interface';

const TopNavbarItem = (props: INavbarItem) => {
  return (
    <span
      className={
        'text-md text-primary-navyblue cursor-pointer leading-4 ' +
        (props.selected ? 'font-bold' : '')
      }
    >
      {props.label}
    </span>
  );
};

export default TopNavbarItem;
